// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { ProjectDetail, MembershipTier, USDPrice, Members, LoadingStatus } from '@app/core/models';
import { EMPTY, of } from 'rxjs';

const mockMembershipTiers: MembershipTier[] = [
  {
    id: '1',
    name: 'Bronze Membership',
    subtiers: [
      {
        price: new USDPrice(100),
        id: 'bronze membership',
        minCompanySize: 100.0,
        maxCompanySize: 400.0
      }
    ]
  },
  {
    id: '2',
    name: 'Silver Membership',
    subtiers: [
      {
        price: new USDPrice(500),
        id: 'silver membership',
        minCompanySize: 100.0,
        maxCompanySize: 400.0
      }
    ]
  },
  {
    id: '3',
    name: 'Nonprofit Membership',
    subtiers: [
      {
        price: new USDPrice(10),
        id: 'nonprofit membership',
        description: 'Special'
      }
    ]
  }
];

const mockMembers: Members = {
  'Gold Membership': [
    {
      id: '1234',
      name: 'Joanne Smith',
      membershipTier: ''
    }
  ]
};

export const mockProjectId = 'a094C000000PuHSQA0';
export const mockProjectDetailList: ProjectDetail[] = [
  {
    status: LoadingStatus.LOAD_COMPLETE,
    id: mockProjectId,
    name: 'Automotive Grade Linux',
    logo: 'https://s3.amazonaws.com/lfx-project-logos/logo_automotive_grade_linux.png',
    members: mockMembers,
    membershipTiers: mockMembershipTiers
  },
  {
    status: LoadingStatus.LOAD_COMPLETE,
    id: 'a0941000005osNn',
    name: 'EdgeX Foundry',
    logo: 'https://s3.amazonaws.com/lfx-project-logos/logo_edgex_foundry.png',
    members: mockMembers,
    membershipTiers: mockMembershipTiers
  },
  {
    id: 'a0941000002wByY',
    status: LoadingStatus.LOAD_COMPLETE,
    name: 'Hyperledger Project',
    logo: 'https://s3.amazonaws.com/lfx-project-logos/logo_hyperledger.png',
    sector: 'Blockchain, Data& Analytics',
    members: mockMembers,
    membershipTiers: mockMembershipTiers
  }
];

export function getMockProject$(projectId: string | undefined) {
  if (!projectId) {
    return EMPTY;
  }

  const project = getMockProject(projectId);
  return project ? of(project) : EMPTY;
}

export function getMockProject(projectId: string) {
  return mockProjectDetailList.find(project => project.id === projectId);
}



// WEBPACK FOOTER //
// ./src/app/core/mocks/project-list.mock.ts